const ACCESS_TOKEN = 'access_token'
export class LocalStorageService {
  static setAccessToken = accessToken =>
    localStorage.setItem(ACCESS_TOKEN, accessToken)

  static getAccessToken = () => localStorage.getItem(ACCESS_TOKEN)

  static removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN)
}
